import React from "react";

export const ICON_PLUS = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <path
        fill="#000"
        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
      />
    </svg>
  );
};

export const ICON_PLUS_CIRCLE = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2514_9814)">
        <path
          d="M8.49971 15.5834C12.4117 15.5834 15.583 12.4121 15.583 8.50008C15.583 4.58806 12.4117 1.41675 8.49971 1.41675C4.5877 1.41675 1.41638 4.58806 1.41638 8.50008C1.41638 12.4121 4.5877 15.5834 8.49971 15.5834Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 5.66675V11.3334"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.66638 8.5H11.333"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2514_9814">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ICON_MINUS = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <path
        fill="#000"
        d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
      />
    </svg>
  );
};

export const ICON_LOGO = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z" />
      </g>
    </svg>
  );
};

export const ICON_LOGOUT = (props) => {
  return (
    <svg
      style={props.styles}
      viewBox="0 0 24 24"
      fill="none"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_774_2018)">
        <path
          d="M4.66634 4.00033H15.333V10.5337H16.6663V4.00033C16.6663 3.6467 16.5259 3.30756 16.2758 3.05752C16.0258 2.80747 15.6866 2.66699 15.333 2.66699H4.66634C4.31272 2.66699 3.97358 2.80747 3.72353 3.05752C3.47348 3.30756 3.33301 3.6467 3.33301 4.00033V20.0003C3.33301 20.3539 3.47348 20.6931 3.72353 20.9431C3.97358 21.1932 4.31272 21.3337 4.66634 21.3337H15.333C15.6866 21.3337 16.0258 21.1932 16.2758 20.9431C16.5259 20.6931 16.6663 20.3539 16.6663 20.0003H4.66634V4.00033Z"
          fill="#7C7E80"
        />
        <path
          d="M18.7729 11.5197C18.6454 11.4105 18.4813 11.3534 18.3136 11.3599C18.1458 11.3664 17.9866 11.4359 17.8679 11.5546C17.7492 11.6734 17.6796 11.8325 17.6731 12.0003C17.6666 12.1681 17.7237 12.3321 17.8329 12.4597L20.0863 14.6663H10.4196C10.2428 14.6663 10.0732 14.7366 9.94819 14.8616C9.82317 14.9866 9.75293 15.1562 9.75293 15.333C9.75293 15.5098 9.82317 15.6794 9.94819 15.8044C10.0732 15.9294 10.2428 15.9997 10.4196 15.9997H20.0863L17.8329 18.3063C17.7631 18.3661 17.7065 18.4397 17.6664 18.5224C17.6264 18.6051 17.6039 18.6952 17.6004 18.787C17.5969 18.8788 17.6123 18.9703 17.6458 19.0559C17.6794 19.1414 17.7302 19.2191 17.7952 19.2841C17.8601 19.3491 17.9378 19.3999 18.0234 19.4334C18.1089 19.467 18.2005 19.4824 18.2923 19.4789C18.3841 19.4753 18.4742 19.4528 18.5569 19.4128C18.6396 19.3728 18.7132 19.3161 18.7729 19.2463L22.6663 15.3797L18.7729 11.5197Z"
          fill="#7C7E80"
        />
      </g>
      <defs>
        <clipPath id="clip0_774_2018">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ICON_HOME = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        d="M6.8915 18.9584H3.52484C1.84984 18.9584 1.0415 18.1834 1.0415 16.5834V3.41675C1.0415 1.81675 1.85817 1.04175 3.52484 1.04175H6.8915C8.5665 1.04175 9.37484 1.81675 9.37484 3.41675V16.5834C9.37484 18.1834 8.55817 18.9584 6.8915 18.9584ZM3.52484 2.29175C2.4665 2.29175 2.2915 2.57508 2.2915 3.41675V16.5834C2.2915 17.4251 2.4665 17.7084 3.52484 17.7084H6.8915C7.94984 17.7084 8.12484 17.4251 8.12484 16.5834V3.41675C8.12484 2.57508 7.94984 2.29175 6.8915 2.29175H3.52484Z"
        fill="#777D94"
      />
      <path
        d="M16.475 9.375H13.1083C11.4333 9.375 10.625 8.63334 10.625 7.10001V3.31667C10.625 1.78334 11.4417 1.04167 13.1083 1.04167H16.475C18.15 1.04167 18.9583 1.78334 18.9583 3.31667V7.09167C18.9583 8.63334 18.1417 9.375 16.475 9.375ZM13.1083 2.29167C11.9917 2.29167 11.875 2.60834 11.875 3.31667V7.09167C11.875 7.80834 11.9917 8.11667 13.1083 8.11667H16.475C17.5917 8.11667 17.7083 7.8 17.7083 7.09167V3.31667C17.7083 2.60001 17.5917 2.29167 16.475 2.29167H13.1083Z"
        fill="#777D94"
      />
      <path
        d="M16.475 18.9583H13.1083C11.4333 18.9583 10.625 18.1417 10.625 16.475V13.1083C10.625 11.4333 11.4417 10.625 13.1083 10.625H16.475C18.15 10.625 18.9583 11.4417 18.9583 13.1083V16.475C18.9583 18.1417 18.1417 18.9583 16.475 18.9583ZM13.1083 11.875C12.125 11.875 11.875 12.125 11.875 13.1083V16.475C11.875 17.4583 12.125 17.7083 13.1083 17.7083H16.475C17.4583 17.7083 17.7083 17.4583 17.7083 16.475V13.1083C17.7083 12.125 17.4583 11.875 16.475 11.875H13.1083Z"
        fill="#777D94"
      />
    </svg>
  );
};

export const ICON_ADMIN_HOME = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.1191 6.38095L21.6191 2.88095C21.5378 2.7996 21.4413 2.73506 21.3351 2.69103C21.2288 2.64699 21.115 2.62433 21 2.62433C20.885 2.62433 20.7711 2.64699 20.6649 2.69103C20.5587 2.73506 20.4622 2.7996 20.3809 2.88095L9.88094 13.381C9.79971 13.4623 9.73529 13.5588 9.69138 13.665C9.64747 13.7712 9.62491 13.8851 9.625 14V17.5C9.625 17.7321 9.71719 17.9546 9.88128 18.1187C10.0454 18.2828 10.2679 18.375 10.5 18.375H14C14.1149 18.3751 14.2288 18.3525 14.335 18.3086C14.4412 18.2647 14.5377 18.2003 14.6191 18.1191L25.1191 7.61908C25.2004 7.53782 25.265 7.44131 25.309 7.33509C25.353 7.22887 25.3757 7.11501 25.3757 7.00002C25.3757 6.88503 25.353 6.77117 25.309 6.66494C25.265 6.55872 25.2004 6.46222 25.1191 6.38095ZM13.638 16.625H11.375V14.362L18.375 7.36205L20.638 9.62502L13.638 16.625ZM21.875 8.38799L19.612 6.12502L21 4.73705L23.263 7.00002L21.875 8.38799ZM24.5 13.125V22.75C24.5 23.2141 24.3156 23.6593 23.9874 23.9875C23.6592 24.3156 23.2141 24.5 22.75 24.5H5.25C4.78587 24.5 4.34075 24.3156 4.01256 23.9875C3.68437 23.6593 3.5 23.2141 3.5 22.75V5.25002C3.5 4.78589 3.68437 4.34077 4.01256 4.01258C4.34075 3.68439 4.78587 3.50002 5.25 3.50002H14.875C15.1071 3.50002 15.3296 3.5922 15.4937 3.7563C15.6578 3.92039 15.75 4.14295 15.75 4.37502C15.75 4.60708 15.6578 4.82964 15.4937 4.99373C15.3296 5.15783 15.1071 5.25002 14.875 5.25002H5.25V22.75H22.75V13.125C22.75 12.893 22.8422 12.6704 23.0063 12.5063C23.1704 12.3422 23.3929 12.25 23.625 12.25C23.8571 12.25 24.0796 12.3422 24.2437 12.5063C24.4078 12.6704 24.5 12.893 24.5 13.125Z"
        fill={props.color}
      />
    </svg>
  );
};

export const ICON_ADMIN_USER_LIST = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8242 17.2725C13.9969 16.4917 14.8873 15.3543 15.3636 14.0285C15.8399 12.7026 15.8768 11.2586 15.469 9.91012C15.0612 8.56161 14.2302 7.38013 13.099 6.54041C11.9678 5.7007 10.5963 5.24731 9.18749 5.24731C7.77866 5.24731 6.40723 5.7007 5.27599 6.54041C4.14476 7.38013 3.31379 8.56161 2.90597 9.91012C2.49814 11.2586 2.53511 12.7026 3.01141 14.0285C3.48771 15.3543 4.37805 16.4917 5.55077 17.2725C3.42944 18.0543 1.61777 19.5011 0.386087 21.397C0.321354 21.4932 0.276391 21.6013 0.25381 21.7151C0.23123 21.8288 0.231482 21.9459 0.254554 22.0596C0.277625 22.1732 0.323055 22.2811 0.388203 22.377C0.453351 22.473 0.536916 22.555 0.634043 22.6183C0.731169 22.6817 0.839919 22.7251 0.953971 22.7461C1.06802 22.767 1.1851 22.7651 1.2984 22.7404C1.4117 22.7157 1.51896 22.6687 1.61395 22.6022C1.70894 22.5357 1.78976 22.451 1.85171 22.3529C2.6462 21.131 3.73335 20.1269 5.01444 19.4317C6.29553 18.7366 7.72997 18.3725 9.18749 18.3725C10.645 18.3725 12.0795 18.7366 13.3605 19.4317C14.6416 20.1269 15.7288 21.131 16.5233 22.3529C16.6516 22.5437 16.8499 22.6763 17.0752 22.722C17.3005 22.7677 17.5347 22.723 17.7273 22.5974C17.9198 22.4718 18.0552 22.2755 18.1042 22.0508C18.1531 21.8262 18.1117 21.5913 17.9889 21.397C16.7572 19.5011 14.9455 18.0543 12.8242 17.2725ZM4.37499 11.8125C4.37499 10.8607 4.65724 9.93021 5.18605 9.1388C5.71485 8.34738 6.46646 7.73055 7.34583 7.36631C8.2252 7.00206 9.19283 6.90676 10.1264 7.09245C11.0599 7.27814 11.9174 7.73649 12.5904 8.40953C13.2635 9.08257 13.7218 9.94007 13.9075 10.8736C14.0932 11.8071 13.9979 12.7748 13.6337 13.6541C13.2694 14.5335 12.6526 15.2851 11.8612 15.8139C11.0698 16.3427 10.1393 16.625 9.18749 16.625C7.91158 16.6235 6.68835 16.116 5.78614 15.2138C4.88393 14.3116 4.37644 13.0884 4.37499 11.8125ZM27.3591 22.6078C27.1647 22.7345 26.928 22.7789 26.7009 22.7311C26.4738 22.6833 26.2751 22.5473 26.1483 22.3529C25.3547 21.1303 24.2677 20.1257 22.9864 19.4309C21.705 18.736 20.2701 18.373 18.8125 18.375C18.5804 18.375 18.3579 18.2828 18.1938 18.1187C18.0297 17.9546 17.9375 17.732 17.9375 17.5C17.9375 17.2679 18.0297 17.0454 18.1938 16.8813C18.3579 16.7172 18.5804 16.625 18.8125 16.625C19.5212 16.6243 20.221 16.4671 20.862 16.1646C21.5029 15.8621 22.0691 15.4218 22.5201 14.8752C22.9711 14.3285 23.2959 13.6889 23.4711 13.0022C23.6463 12.3155 23.6677 11.5986 23.5337 10.9026C23.3997 10.2067 23.1136 9.54895 22.696 8.97638C22.2783 8.40381 21.7393 7.93055 21.1176 7.59042C20.4958 7.25029 19.8066 7.05169 19.0992 7.0088C18.3918 6.96591 17.6836 7.0798 17.0253 7.34232C16.918 7.38872 16.8024 7.41314 16.6855 7.41412C16.5686 7.41511 16.4526 7.39265 16.3445 7.34807C16.2364 7.3035 16.1384 7.2377 16.0561 7.15458C15.9739 7.07146 15.9091 6.97269 15.8657 6.86412C15.8223 6.75555 15.801 6.63938 15.8033 6.52247C15.8055 6.40555 15.8311 6.29027 15.8787 6.18344C15.9262 6.07661 15.9947 5.98038 16.08 5.90046C16.1654 5.82053 16.2659 5.75853 16.3756 5.7181C17.8822 5.11725 19.558 5.09563 21.0796 5.65741C22.6012 6.21918 23.8608 7.32455 24.6155 8.76028C25.3702 10.196 25.5664 11.8603 25.1664 13.4322C24.7664 15.0041 23.7984 16.3722 22.4492 17.2725C24.5705 18.0543 26.3822 19.5011 27.6139 21.397C27.7406 21.5914 27.785 21.8281 27.7372 22.0552C27.6894 22.2822 27.5534 22.481 27.3591 22.6078Z"
        fill={props.color}
      />
    </svg>
  );
};

export const ICON_NEW_USER_HISTORY = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 14.875C28 15.107 27.9078 15.3296 27.7437 15.4937C27.5796 15.6578 27.357 15.75 27.125 15.75H25.375V17.5C25.375 17.732 25.2828 17.9546 25.1187 18.1187C24.9546 18.2828 24.732 18.375 24.5 18.375C24.2679 18.375 24.0453 18.2828 23.8812 18.1187C23.7171 17.9546 23.625 17.732 23.625 17.5V15.75H21.875C21.6429 15.75 21.4203 15.6578 21.2562 15.4937C21.0921 15.3296 21 15.107 21 14.875C21 14.6429 21.0921 14.4204 21.2562 14.2563C21.4203 14.0922 21.6429 14 21.875 14H23.625V12.25C23.625 12.0179 23.7171 11.7954 23.8812 11.6313C24.0453 11.4672 24.2679 11.375 24.5 11.375C24.732 11.375 24.9546 11.4672 25.1187 11.6313C25.2828 11.7954 25.375 12.0179 25.375 12.25V14H27.125C27.357 14 27.5796 14.0922 27.7437 14.2563C27.9078 14.4204 28 14.6429 28 14.875ZM21.6704 21.3117C21.8198 21.4895 21.8925 21.7194 21.8724 21.9508C21.8523 22.1821 21.7411 22.3961 21.5632 22.5454C21.3854 22.6948 21.1555 22.7675 20.9242 22.7474C20.6928 22.7273 20.4789 22.6161 20.3295 22.4383C18.1289 19.8176 15.1036 18.375 11.8125 18.375C8.52137 18.375 5.49605 19.8176 3.29543 22.4383C3.14604 22.6159 2.93218 22.727 2.70091 22.747C2.46964 22.767 2.2399 22.6943 2.06223 22.5449C1.88455 22.3955 1.7735 22.1817 1.7535 21.9504C1.7335 21.7191 1.80619 21.4894 1.95559 21.3117C3.58965 19.367 5.62184 17.9856 7.88043 17.2462C6.50876 16.3919 5.45265 15.1141 4.87189 13.6061C4.29112 12.0981 4.21729 10.442 4.66158 8.88829C5.10586 7.3346 6.04408 5.96788 7.33429 4.99489C8.6245 4.02191 10.1965 3.49561 11.8125 3.49561C13.4284 3.49561 15.0004 4.02191 16.2906 4.99489C17.5808 5.96788 18.5191 7.3346 18.9633 8.88829C19.4076 10.442 19.3338 12.0981 18.753 13.6061C18.1723 15.1141 17.1162 16.3919 15.7445 17.2462C18.0031 17.9856 20.0353 19.367 21.6704 21.3117ZM11.8125 16.625C12.9373 16.625 14.037 16.2914 14.9723 15.6665C15.9076 15.0415 16.6366 14.1532 17.067 13.114C17.4975 12.0747 17.6101 10.9312 17.3907 9.8279C17.1712 8.72464 16.6295 7.71122 15.8341 6.91581C15.0387 6.1204 14.0253 5.57872 12.922 5.35926C11.8188 5.13981 10.6752 5.25244 9.63595 5.68291C8.59669 6.11339 7.70843 6.84237 7.08348 7.77767C6.45853 8.71298 6.12496 9.8126 6.12496 10.9375C6.1267 12.4454 6.72647 13.891 7.79271 14.9572C8.85895 16.0235 10.3046 16.6232 11.8125 16.625Z"
        fill={props.color}
      />
    </svg>
  );
};

export const ICON_NOTIFICATION = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2593 19.2434C23.6523 18.1978 22.75 15.2392 22.75 11.375C22.75 9.05436 21.8281 6.82876 20.1871 5.18782C18.5462 3.54687 16.3206 2.625 14 2.625C11.6793 2.625 9.45371 3.54687 7.81277 5.18782C6.17183 6.82876 5.24995 9.05436 5.24995 11.375C5.24995 15.2403 4.34652 18.1978 3.73948 19.2434C3.58447 19.5093 3.50229 19.8113 3.50123 20.119C3.50017 20.4267 3.58028 20.7293 3.73347 20.9962C3.88665 21.2631 4.10751 21.4848 4.37376 21.6391C4.64 21.7934 4.94223 21.8748 5.24995 21.875H9.71355C9.91542 22.8628 10.4523 23.7506 11.2333 24.3882C12.0144 25.0258 12.9917 25.374 14 25.374C15.0082 25.374 15.9855 25.0258 16.7666 24.3882C17.5476 23.7506 18.0845 22.8628 18.2864 21.875H22.75C23.0576 21.8746 23.3597 21.7931 23.6258 21.6387C23.8919 21.4843 24.1126 21.2625 24.2656 20.9957C24.4187 20.7288 24.4987 20.4263 24.4976 20.1187C24.4965 19.8111 24.4143 19.5092 24.2593 19.2434ZM14 23.625C13.4573 23.6248 12.9279 23.4565 12.4849 23.1431C12.0418 22.8297 11.7068 22.3867 11.5259 21.875H16.474C16.2931 22.3867 15.9581 22.8297 15.515 23.1431C15.072 23.4565 14.5427 23.6248 14 23.625ZM5.24995 20.125C6.09214 18.6769 6.99995 15.3212 6.99995 11.375C6.99995 9.51848 7.73745 7.73801 9.05021 6.42525C10.363 5.1125 12.1434 4.375 14 4.375C15.8565 4.375 17.6369 5.1125 18.9497 6.42525C20.2625 7.73801 21 9.51848 21 11.375C21 15.318 21.9056 18.6736 22.75 20.125H5.24995Z"
        fill={props.color}
      />
    </svg>
  );
};

export const ICON_MANAGE_HISTORY = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.375 14.9472C25.1891 17.1085 24.3898 19.1716 23.0712 20.894C21.7525 22.6164 19.9694 23.9264 17.9315 24.6698C15.8937 25.4132 13.6859 25.5591 11.568 25.0904C9.45002 24.6216 7.50999 23.5577 5.97613 22.0239C4.44227 20.49 3.3784 18.55 2.90967 16.432C2.44094 14.3141 2.58686 12.1063 3.33026 10.0685C4.07366 8.03064 5.38362 6.24751 7.10601 4.92887C8.8284 3.61023 10.8916 2.81094 13.0528 2.62504C13.1677 2.61556 13.2833 2.62881 13.3931 2.66402C13.5029 2.69924 13.6047 2.75573 13.6927 2.83028C13.7806 2.90483 13.853 2.99597 13.9058 3.0985C13.9585 3.20103 13.9905 3.31295 14 3.42786C14.0095 3.54276 13.9962 3.65841 13.961 3.7682C13.9258 3.87799 13.8693 3.97976 13.7947 4.06772C13.7202 4.15567 13.6291 4.22808 13.5265 4.28081C13.424 4.33354 13.3121 4.36556 13.1972 4.37504C11.368 4.53221 9.6217 5.20855 8.16385 6.3245C6.706 7.44045 5.5972 8.94957 4.96793 10.6743C4.33866 12.399 4.21509 14.2676 4.61176 16.0602C5.00843 17.8528 5.90884 19.4948 7.20705 20.793C8.50526 22.0912 10.1472 22.9916 11.9398 23.3883C13.7324 23.7849 15.601 23.6614 17.3257 23.0321C19.0504 22.4028 20.5596 21.294 21.6755 19.8362C22.7915 18.3783 23.4678 16.6321 23.625 14.8029C23.6441 14.5708 23.7547 14.3558 23.9323 14.2053C24.1099 14.0547 24.3401 13.9809 24.5722 14C24.8042 14.0192 25.0192 14.1297 25.1697 14.3074C25.3203 14.485 25.3941 14.7152 25.375 14.9472ZM13.125 7.87504V14C13.125 14.2321 13.2172 14.4547 13.3813 14.6188C13.5454 14.7829 13.7679 14.875 14 14.875H20.125C20.357 14.875 20.5796 14.7829 20.7437 14.6188C20.9078 14.4547 21 14.2321 21 14C21 13.768 20.9078 13.5454 20.7437 13.3813C20.5796 13.2172 20.357 13.125 20.125 13.125H14.875V7.87504C14.875 7.64298 14.7828 7.42042 14.6187 7.25632C14.4546 7.09223 14.232 7.00004 14 7.00004C13.7679 7.00004 13.5454 7.09223 13.3813 7.25632C13.2172 7.42042 13.125 7.64298 13.125 7.87504ZM17.5 5.25004C17.7596 5.25004 18.0133 5.17307 18.2292 5.02885C18.445 4.88463 18.6132 4.67964 18.7126 4.43982C18.8119 4.19999 18.8379 3.93609 18.7873 3.68149C18.7366 3.42689 18.6116 3.19302 18.4281 3.00947C18.2445 2.82591 18.0106 2.70091 17.756 2.65026C17.5014 2.59962 17.2375 2.62561 16.9977 2.72495C16.7579 2.82429 16.5529 2.99252 16.4087 3.20836C16.2645 3.4242 16.1875 3.67796 16.1875 3.93754C16.1875 4.28564 16.3258 4.61948 16.5719 4.86562C16.818 5.11176 17.1519 5.25004 17.5 5.25004ZM21.4375 7.87504C21.6971 7.87504 21.9508 7.79807 22.1667 7.65385C22.3825 7.50963 22.5507 7.30464 22.6501 7.06482C22.7494 6.82499 22.7754 6.56109 22.7248 6.30649C22.6741 6.05189 22.5491 5.81802 22.3656 5.63447C22.182 5.45091 21.9481 5.32591 21.6935 5.27526C21.4389 5.22462 21.175 5.25061 20.9352 5.34995C20.6954 5.44929 20.4904 5.61752 20.3462 5.83336C20.202 6.0492 20.125 6.30296 20.125 6.56254C20.125 6.91064 20.2633 7.24448 20.5094 7.49062C20.7555 7.73676 21.0894 7.87504 21.4375 7.87504ZM24.0625 11.8125C24.3221 11.8125 24.5758 11.7356 24.7917 11.5913C25.0075 11.4471 25.1757 11.2421 25.2751 11.0023C25.3744 10.7625 25.4004 10.4986 25.3498 10.244C25.2991 9.98939 25.1741 9.75552 24.9906 9.57197C24.807 9.38841 24.5731 9.26341 24.3185 9.21276C24.0639 9.16212 23.8 9.18811 23.5602 9.28745C23.3204 9.38679 23.1154 9.55502 22.9712 9.77086C22.827 9.9867 22.75 10.2405 22.75 10.5C22.75 10.8481 22.8883 11.182 23.1344 11.4281C23.3805 11.6743 23.7144 11.8125 24.0625 11.8125Z"
        fill={props.color}
      />
    </svg>
  );
};

export const ICON_HOMEFILL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M22.58 7.35L12.475 1.897c-.297-.16-.654-.16-.95 0L1.425 7.35c-.486.264-.667.87-.405 1.356.18.335.525.525.88.525.16 0 .324-.038.475-.12l.734-.396 1.59 11.25c.216 1.214 1.31 2.062 2.66 2.062h9.282c1.35 0 2.444-.848 2.662-2.088l1.588-11.225.737.398c.485.263 1.092.082 1.354-.404.263-.486.08-1.093-.404-1.355zM12 15.435c-1.795 0-3.25-1.455-3.25-3.25s1.455-3.25 3.25-3.25 3.25 1.455 3.25 3.25-1.455 3.25-3.25 3.25z" />
      </g>
    </svg>
  );
};

export const ICON_HASH = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        d="M9.16666 17.2917C4.68332 17.2917 1.04166 13.65 1.04166 9.16666C1.04166 4.68332 4.68332 1.04166 9.16666 1.04166C13.65 1.04166 17.2917 4.68332 17.2917 9.16666C17.2917 13.65 13.65 17.2917 9.16666 17.2917ZM9.16666 2.29166C5.37499 2.29166 2.29166 5.37499 2.29166 9.16666C2.29166 12.9583 5.37499 16.0417 9.16666 16.0417C12.9583 16.0417 16.0417 12.9583 16.0417 9.16666C16.0417 5.37499 12.9583 2.29166 9.16666 2.29166Z"
        fill="#777D94"
      />
      <path
        d="M16.8 18.9917C16.7333 18.9917 16.6667 18.9833 16.6083 18.975C16.2167 18.925 15.5083 18.6583 15.1083 17.4667C14.9 16.8417 14.975 16.2167 15.3167 15.7417C15.6583 15.2667 16.2333 15 16.8917 15C17.7417 15 18.4083 15.325 18.7083 15.9C19.0083 16.475 18.925 17.2083 18.45 17.9167C17.8583 18.8083 17.2167 18.9917 16.8 18.9917ZM16.3 17.075C16.4417 17.5083 16.6417 17.725 16.775 17.7417C16.9083 17.7583 17.1583 17.6 17.4167 17.225C17.6583 16.8667 17.675 16.6083 17.6167 16.4917C17.5583 16.375 17.325 16.25 16.8917 16.25C16.6333 16.25 16.4417 16.3333 16.3333 16.475C16.2333 16.6167 16.2167 16.8333 16.3 17.075Z"
        fill="#777D94"
      />
    </svg>
  );
};

export const ICON_CHAT = ({ width = 21, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <g clipPath="url(#clip0_2061_2424)">
        <path
          d="M10.4492 10.9375C10.967 10.9375 11.3867 10.5178 11.3867 10C11.3867 9.48223 10.967 9.0625 10.4492 9.0625C9.93145 9.0625 9.51172 9.48223 9.51172 10C9.51172 10.5178 9.93145 10.9375 10.4492 10.9375Z"
          fill="#2B4773"
        />
        <path
          d="M7.01172 10.9375C7.52949 10.9375 7.94922 10.5178 7.94922 10C7.94922 9.48223 7.52949 9.0625 7.01172 9.0625C6.49395 9.0625 6.07422 9.48223 6.07422 10C6.07422 10.5178 6.49395 10.9375 7.01172 10.9375Z"
          fill="#2B4773"
        />
        <path
          d="M13.8867 10.9375C14.4045 10.9375 14.8242 10.5178 14.8242 10C14.8242 9.48223 14.4045 9.0625 13.8867 9.0625C13.369 9.0625 12.9492 9.48223 12.9492 10C12.9492 10.5178 13.369 10.9375 13.8867 10.9375Z"
          fill="#2B4773"
        />
        <path
          d="M6.69401 16.4932C8.26943 17.405 10.1227 17.7127 11.9082 17.359C13.6938 17.0053 15.2898 16.0143 16.3986 14.5708C17.5075 13.1273 18.0535 11.3298 17.9349 9.51341C17.8164 7.69704 17.0413 5.98577 15.7542 4.69866C14.4671 3.41156 12.7558 2.63646 10.9394 2.51789C9.12304 2.39932 7.32553 2.94537 5.88202 4.05422C4.43851 5.16308 3.44752 6.75906 3.09382 8.54461C2.74012 10.3302 3.04785 12.1834 3.95964 13.7588L2.9823 16.6768C2.94557 16.7869 2.94024 16.9051 2.9669 17.0181C2.99357 17.131 3.05117 17.2344 3.13325 17.3165C3.21534 17.3985 3.31866 17.4561 3.43164 17.4828C3.54462 17.5095 3.6628 17.5041 3.77292 17.4674L6.69401 16.4932Z"
          stroke="#2B4773"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2061_2424">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.449219)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ICON_HASHFILL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M20.585 9.468c.66 0 1.2-.538 1.2-1.2 0-.662-.54-1.2-1.2-1.2h-3.22l.31-3.547c.027-.318-.07-.63-.277-.875-.206-.245-.495-.396-.822-.425-.65-.035-1.235.432-1.293 1.093l-.326 3.754H9.9l.308-3.545c.06-.658-.43-1.242-1.097-1.302-.665-.05-1.235.43-1.293 1.092l-.325 3.754h-3.33c-.663 0-1.2.538-1.2 1.2 0 .662.538 1.2 1.2 1.2h3.122l-.44 5.064H3.416c-.662 0-1.2.54-1.2 1.2s.538 1.202 1.2 1.202h3.22l-.31 3.548c-.057.657.432 1.24 1.09 1.3l.106.005c.626 0 1.14-.472 1.195-1.098l.327-3.753H14.1l-.308 3.544c-.06.658.43 1.242 1.09 1.302l.106.005c.617 0 1.142-.482 1.195-1.098l.325-3.753h3.33c.66 0 1.2-.54 1.2-1.2s-.54-1.202-1.2-1.202h-3.122l.44-5.064h3.43zm-5.838 0l-.44 5.063H9.253l.44-5.062h5.055z" />
      </g>
    </svg>
  );
};

export const ICON_BELL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M21.697 16.468c-.02-.016-2.14-1.64-2.103-6.03.02-2.532-.812-4.782-2.347-6.335C15.872 2.71 14.01 1.94 12.005 1.93h-.013c-2.004.01-3.866.78-5.242 2.174-1.534 1.553-2.368 3.802-2.346 6.334.037 4.33-2.02 5.967-2.102 6.03-.26.193-.366.53-.265.838.102.308.39.515.712.515h4.92c.102 2.31 1.997 4.16 4.33 4.16s4.226-1.85 4.327-4.16h4.922c.322 0 .61-.206.71-.514.103-.307-.003-.645-.263-.838zM12 20.478c-1.505 0-2.73-1.177-2.828-2.658h5.656c-.1 1.48-1.323 2.66-2.828 2.66zM4.38 16.32c.74-1.132 1.548-3.028 1.524-5.896-.018-2.16.644-3.982 1.913-5.267C8.91 4.05 10.397 3.437 12 3.43c1.603.008 3.087.62 4.18 1.728 1.27 1.285 1.933 3.106 1.915 5.267-.024 2.868.785 4.765 1.525 5.896H4.38z" />
      </g>
    </svg>
  );
};

export const ICON_BELLFILL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M21.697 16.468c-.02-.016-2.14-1.64-2.103-6.03.02-2.533-.812-4.782-2.347-6.334-1.375-1.393-3.237-2.164-5.242-2.172h-.013c-2.004.008-3.866.78-5.242 2.172-1.534 1.553-2.367 3.802-2.346 6.333.037 4.332-2.02 5.967-2.102 6.03-.26.194-.366.53-.265.838s.39.515.713.515h4.494c.1 2.544 2.188 4.587 4.756 4.587s4.655-2.043 4.756-4.587h4.494c.324 0 .61-.208.712-.515s-.005-.644-.265-.837zM12 20.408c-1.466 0-2.657-1.147-2.756-2.588h5.512c-.1 1.44-1.29 2.587-2.756 2.587z" />
      </g>
    </svg>
  );
};

export const ICON_INBOX = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.25 3.018H4.75C3.233 3.018 2 4.252 2 5.77v12.495c0 1.518 1.233 2.753 2.75 2.753h14.5c1.517 0 2.75-1.235 2.75-2.753V5.77c0-1.518-1.233-2.752-2.75-2.752zm-14.5 1.5h14.5c.69 0 1.25.56 1.25 1.25v.714l-8.05 5.367c-.273.18-.626.182-.9-.002L3.5 6.482v-.714c0-.69.56-1.25 1.25-1.25zm14.5 14.998H4.75c-.69 0-1.25-.56-1.25-1.25V8.24l7.24 4.83c.383.256.822.384 1.26.384.44 0 .877-.128 1.26-.383l7.24-4.83v10.022c0 .69-.56 1.25-1.25 1.25z" />
      </g>
    </svg>
  );
};

export const ICON_INBOXFILL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M11.55 12.082c.273.182.627.182.9 0L22 5.716V5.5c0-1.24-1.01-2.25-2.25-2.25H4.25C3.01 3.25 2 4.26 2 5.5v.197l9.55 6.385z" />
        <path d="M13.26 13.295c-.383.255-.82.382-1.26.382s-.877-.127-1.26-.383L2 7.452v11.67c0 1.24 1.01 2.25 2.25 2.25h15.5c1.24 0 2.25-1.01 2.25-2.25V7.47l-8.74 5.823z" />
      </g>
    </svg>
  );
};

export const ICON_BOOKMARK = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.9 23.5c-.157 0-.312-.05-.442-.144L12 17.928l-7.458 5.43c-.228.164-.53.19-.782.06-.25-.127-.41-.385-.41-.667V5.6c0-1.24 1.01-2.25 2.25-2.25h12.798c1.24 0 2.25 1.01 2.25 2.25v17.15c0 .282-.158.54-.41.668-.106.055-.223.082-.34.082zM12 16.25c.155 0 .31.048.44.144l6.71 4.883V5.6c0-.412-.337-.75-.75-.75H5.6c-.413 0-.75.338-.75.75v15.677l6.71-4.883c.13-.096.285-.144.44-.144z" />
      </g>
    </svg>
  );
};

export const ICON_BOOKMARKFILL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.9 23.5c-.2 0-.3 0-.4-.1L12 17.9l-7.5 5.4c-.2.2-.5.2-.8.1-.2-.1-.4-.4-.4-.7V5.6c0-1.2 1-2.2 2.2-2.2h12.8c1.2 0 2.2 1 2.2 2.2v17.1c0 .3-.2.5-.4.7 0 .1-.1.1-.2.1z" />
      </g>
    </svg>
  );
};

export const ICON_LIST = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.75 22H4.25C3.01 22 2 20.99 2 19.75V4.25C2 3.01 3.01 2 4.25 2h15.5C20.99 2 22 3.01 22 4.25v15.5c0 1.24-1.01 2.25-2.25 2.25zM4.25 3.5c-.414 0-.75.337-.75.75v15.5c0 .413.336.75.75.75h15.5c.414 0 .75-.337.75-.75V4.25c0-.413-.336-.75-.75-.75H4.25z" />
        <path d="M17 8.64H7c-.414 0-.75-.337-.75-.75s.336-.75.75-.75h10c.414 0 .75.335.75.75s-.336.75-.75.75zm0 4.11H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75zm-5 4.11H7c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h5c.414 0 .75.337.75.75s-.336.75-.75.75z" />
      </g>
    </svg>
  );
};

export const ICON_LISTFILL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.75 2H4.25C3.013 2 2 3.013 2 4.25v15.5C2 20.987 3.013 22 4.25 22h15.5c1.237 0 2.25-1.013 2.25-2.25V4.25C22 3.013 20.987 2 19.75 2zM11 16.75H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4c.414 0 .75.336.75.75s-.336.75-.75.75zm6-4H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75zm0-4H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75z" />
      </g>
    </svg>
  );
};

export const ICON_USER = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        d="M10.0001 18.9583C9.44181 18.9583 8.87514 18.8166 8.37514 18.525L3.42514 15.6666C2.42514 15.0833 1.80014 14.0083 1.80014 12.85V7.15C1.80014 5.99167 2.42514 4.91667 3.42514 4.33333L8.37514 1.47501C9.37514 0.891673 10.6168 0.891673 11.6251 1.47501L16.5751 4.33333C17.5751 4.91667 18.2001 5.99167 18.2001 7.15V12.85C18.2001 14.0083 17.5751 15.0833 16.5751 15.6666L11.6251 18.525C11.1251 18.8166 10.5585 18.9583 10.0001 18.9583ZM10.0001 2.29166C9.65847 2.29166 9.30847 2.38333 9.00014 2.55833L4.05014 5.41666C3.43347 5.77499 3.05014 6.43334 3.05014 7.15V12.85C3.05014 13.5583 3.43347 14.225 4.05014 14.5833L9.00014 17.4417C9.61681 17.8 10.3835 17.8 11.0001 17.4417L15.9501 14.5833C16.5668 14.225 16.9501 13.5666 16.9501 12.85V7.15C16.9501 6.44167 16.5668 5.77499 15.9501 5.41666L11.0001 2.55833C10.6918 2.38333 10.3418 2.29166 10.0001 2.29166Z"
        fill="#777D94"
      />
      <path
        d="M9.99992 9.79173C8.58326 9.79173 7.43326 8.64171 7.43326 7.22505C7.43326 5.80838 8.58326 4.65842 9.99992 4.65842C11.4166 4.65842 12.5666 5.80838 12.5666 7.22505C12.5666 8.64171 11.4166 9.79173 9.99992 9.79173ZM9.99992 5.90842C9.27492 5.90842 8.68326 6.50005 8.68326 7.22505C8.68326 7.95005 9.27492 8.54173 9.99992 8.54173C10.7249 8.54173 11.3166 7.95005 11.3166 7.22505C11.3166 6.50005 10.7249 5.90842 9.99992 5.90842Z"
        fill="#777D94"
      />
      <path
        d="M13.3333 14.5084C12.9917 14.5084 12.7083 14.2251 12.7083 13.8834C12.7083 12.7334 11.4917 11.7918 9.99999 11.7918C8.50832 11.7918 7.29166 12.7334 7.29166 13.8834C7.29166 14.2251 7.00832 14.5084 6.66666 14.5084C6.32499 14.5084 6.04166 14.2251 6.04166 13.8834C6.04166 12.0417 7.81666 10.5418 9.99999 10.5418C12.1833 10.5418 13.9583 12.0417 13.9583 13.8834C13.9583 14.2251 13.675 14.5084 13.3333 14.5084Z"
        fill="#777D94"
      />
    </svg>
  );
};

export const ICON_USERFILL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M12.225 12.165c-1.356 0-2.872-.15-3.84-1.256-.814-.93-1.077-2.368-.805-4.392.38-2.826 2.116-4.513 4.646-4.513s4.267 1.687 4.646 4.513c.272 2.024.008 3.46-.806 4.392-.97 1.106-2.485 1.255-3.84 1.255zm5.849 9.85H6.376c-.663 0-1.25-.28-1.65-.786-.422-.534-.576-1.27-.41-1.968.834-3.53 4.086-5.997 7.908-5.997s7.074 2.466 7.91 5.997c.164.698.01 1.434-.412 1.967-.4.505-.985.785-1.648.785z" />
      </g>
    </svg>
  );
};

export const ICON_SETTINGS = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke="#777D94"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66666 10.7334V9.2667C1.66666 8.40003 2.37499 7.68336 3.24999 7.68336C4.75832 7.68336 5.37499 6.6167 4.61666 5.30836C4.18332 4.55836 4.44166 3.58336 5.19999 3.15003L6.64166 2.32503C7.29999 1.93336 8.14999 2.1667 8.54166 2.82503L8.63332 2.98336C9.38332 4.2917 10.6167 4.2917 11.375 2.98336L11.4667 2.82503C11.8583 2.1667 12.7083 1.93336 13.3667 2.32503L14.8083 3.15003C15.5667 3.58336 15.825 4.55836 15.3917 5.30836C14.6333 6.6167 15.25 7.68336 16.7583 7.68336C17.625 7.68336 18.3417 8.3917 18.3417 9.2667V10.7334C18.3417 11.6 17.6333 12.3167 16.7583 12.3167C15.25 12.3167 14.6333 13.3834 15.3917 14.6917C15.825 15.45 15.5667 16.4167 14.8083 16.85L13.3667 17.675C12.7083 18.0667 11.8583 17.8334 11.4667 17.175L11.375 17.0167C10.625 15.7084 9.39166 15.7084 8.63332 17.0167L8.54166 17.175C8.14999 17.8334 7.29999 18.0667 6.64166 17.675L5.19999 16.85C4.44166 16.4167 4.18332 15.4417 4.61666 14.6917C5.37499 13.3834 4.75832 12.3167 3.24999 12.3167C2.37499 12.3167 1.66666 11.6 1.66666 10.7334Z"
        stroke="#777D94"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_CARVIBES = (props) => {
  return (
    <svg
      style={props.styles}
      viewBox="0 0 24 24"
      className="r-jwli3a r-4qtqp9 r-yyyyoo r-1q142lx r-50lct3 r-dnmrzs r-bnwqim r-1plcrui r-lrvibr"
    >
      <g>
        <path d="M8.8 7.2H5.6V3.9c0-.4-.3-.8-.8-.8s-.7.4-.7.8v3.3H.8c-.4 0-.8.3-.8.8s.3.8.8.8h3.3v3.3c0 .4.3.8.8.8s.8-.3.8-.8V8.7H9c.4 0 .8-.3.8-.8s-.5-.7-1-.7zm15-4.9v-.1h-.1c-.1 0-9.2 1.2-14.4 11.7-3.8 7.6-3.6 9.9-3.3 9.9.3.1 3.4-6.5 6.7-9.2 5.2-1.1 6.6-3.6 6.6-3.6s-1.5.2-2.1.2c-.8 0-1.4-.2-1.7-.3 1.3-1.2 2.4-1.5 3.5-1.7.9-.2 1.8-.4 3-1.2 2.2-1.6 1.9-5.5 1.8-5.7z" />
      </g>
    </svg>
  );
};

export const ICON_IMGUPLOAD = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.75 2H4.25C3.01 2 2 3.01 2 4.25v15.5C2 20.99 3.01 22 4.25 22h15.5c1.24 0 2.25-1.01 2.25-2.25V4.25C22 3.01 20.99 2 19.75 2zM4.25 3.5h15.5c.413 0 .75.337.75.75v9.676l-3.858-3.858c-.14-.14-.33-.22-.53-.22h-.003c-.2 0-.393.08-.532.224l-4.317 4.384-1.813-1.806c-.14-.14-.33-.22-.53-.22-.193-.03-.395.08-.535.227L3.5 17.642V4.25c0-.413.337-.75.75-.75zm-.744 16.28l5.418-5.534 6.282 6.254H4.25c-.402 0-.727-.322-.744-.72zm16.244.72h-2.42l-5.007-4.987 3.792-3.85 4.385 4.384v3.703c0 .413-.337.75-.75.75z" />
        <circle cx="8.868" cy="8.309" r="1.542" />
      </g>
    </svg>
  );
};

export const ICON_REPLY = (props) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2521 19.28C16.4242 19.28 19.8064 15.9669 19.8064 11.88C19.8064 7.7931 16.4242 4.48001 12.2521 4.48001C8.08 4.48001 4.69783 7.7931 4.69783 11.88C4.69783 13.0638 4.98158 14.1826 5.48609 15.1748C5.62016 15.4385 5.66478 15.7399 5.58706 16.0245L5.13712 17.6717C4.9418 18.3868 5.60964 19.041 6.33964 18.8497L8.02125 18.4089C8.31175 18.3328 8.61942 18.3765 8.88859 18.5078C9.9015 19.0021 11.0437 19.28 12.2521 19.28Z"
        fill="#1E1F23"
      />
      <path
        d="M14.5184 11.88C14.5184 12.2887 14.8566 12.62 15.2738 12.62C15.6911 12.62 16.0293 12.2887 16.0293 11.88C16.0293 11.4713 15.6911 11.14 15.2738 11.14C14.8566 11.14 14.5184 11.4713 14.5184 11.88Z"
        fill="white"
      />
      <path
        d="M11.4967 11.88C11.4967 12.2887 11.8349 12.62 12.2521 12.62C12.6693 12.62 13.0076 12.2887 13.0076 11.88C13.0076 11.4713 12.6693 11.14 12.2521 11.14C11.8349 11.14 11.4967 11.4713 11.4967 11.88Z"
        fill="white"
      />
      <path
        d="M8.47497 11.88C8.47497 12.2887 8.81319 12.62 9.2304 12.62C9.64762 12.62 9.98583 12.2887 9.98583 11.88C9.98583 11.4713 9.64762 11.14 9.2304 11.14C8.81319 11.14 8.47497 11.4713 8.47497 11.88Z"
        fill="white"
      />
    </svg>
  );
};

export const ICON_RECARVIBES = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z" />
      </g>
    </svg>
  );
};

export const ICON_HEART_DARK = ({ width = 17, height = 12, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 15"
      fill="gray"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        d="M5.78753 0.0119019C2.89901 0.0119019 0.438148 2.12759 0.438148 4.87534C0.438148 6.7709 1.34427 8.36678 2.54517 9.68876C3.74195 11.0062 5.28598 12.112 6.68184 13.0376L9.09022 14.6345C9.35398 14.8094 9.69985 14.8094 9.9636 14.6345L12.372 13.0376C13.7678 12.112 15.3119 11.0062 16.5086 9.68876C17.7096 8.36678 18.6157 6.7709 18.6157 4.87534C18.6157 2.12759 16.1548 0.0119019 13.2663 0.0119019C11.7773 0.0119019 10.4671 0.695803 9.52691 1.58072C8.58671 0.695803 7.2765 0.0119019 5.78753 0.0119019Z"
        fill="gray"
      />
    </svg>
  );
};

export const ICON_HEART = (props) => {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.78753 0.0119019C2.89901 0.0119019 0.438148 2.12759 0.438148 4.87534C0.438148 6.7709 1.34427 8.36678 2.54517 9.68876C3.74195 11.0062 5.28598 12.112 6.68184 13.0376L9.09022 14.6345C9.35398 14.8094 9.69985 14.8094 9.9636 14.6345L12.372 13.0376C13.7678 12.112 15.3119 11.0062 16.5086 9.68876C17.7096 8.36678 18.6157 6.7709 18.6157 4.87534C18.6157 2.12759 16.1548 0.0119019 13.2663 0.0119019C11.7773 0.0119019 10.4671 0.695803 9.52691 1.58072C8.58671 0.695803 7.2765 0.0119019 5.78753 0.0119019Z"
        fill="white"
      />
    </svg>
  );
};

export const ICON_HEARTFULL = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12z" />
      </g>
    </svg>
  );
};

export const ICON_SHARE = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M17.53 7.47l-5-5c-.293-.293-.768-.293-1.06 0l-5 5c-.294.293-.294.768 0 1.06s.767.294 1.06 0l3.72-3.72V15c0 .414.336.75.75.75s.75-.336.75-.75V4.81l3.72 3.72c.146.147.338.22.53.22s.384-.072.53-.22c.293-.293.293-.767 0-1.06z" />
        <path d="M19.708 21.944H4.292C3.028 21.944 2 20.916 2 19.652V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 1.264-1.028 2.292-2.292 2.292z" />
      </g>
    </svg>
  );
};

export const ICON_ARROWFRONT = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
        fill="black"
      />
    </svg>
  );
};

export const ICON_ARROWBACK = ({ width = 24, height = 24, color = "black", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
        fill={color}
      />
    </svg>
  );
};

export const ICON_MARKDOWN = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M12 14.315c-2.088 0-3.787-1.698-3.787-3.786S9.913 6.74 12 6.74s3.787 1.7 3.787 3.787-1.7 3.785-3.787 3.785zm0-6.073c-1.26 0-2.287 1.026-2.287 2.287S10.74 12.814 12 12.814s2.287-1.025 2.287-2.286S13.26 8.24 12 8.24z" />
        <path d="M20.692 10.69C20.692 5.9 16.792 2 12 2s-8.692 3.9-8.692 8.69c0 1.902.603 3.708 1.743 5.223l.003-.002.007.015c1.628 2.07 6.278 5.757 6.475 5.912.138.11.302.163.465.163.163 0 .327-.053.465-.162.197-.155 4.847-3.84 6.475-5.912l.007-.014.002.002c1.14-1.516 1.742-3.32 1.742-5.223zM12 20.29c-1.224-.99-4.52-3.715-5.756-5.285-.94-1.25-1.436-2.742-1.436-4.312C4.808 6.727 8.035 3.5 12 3.5s7.192 3.226 7.192 7.19c0 1.57-.497 3.062-1.436 4.313-1.236 1.57-4.532 4.294-5.756 5.285z" />
      </g>
    </svg>
  );
};

export const ICON_DATE = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.708 2H4.292C3.028 2 2 3.028 2 4.292v15.416C2 20.972 3.028 22 4.292 22h15.416C20.972 22 22 20.972 22 19.708V4.292C22 3.028 20.972 2 19.708 2zm.792 17.708c0 .437-.355.792-.792.792H4.292c-.437 0-.792-.355-.792-.792V6.418c0-.437.354-.79.79-.792h15.42c.436 0 .79.355.79.79V19.71z" />
        <circle cx="7.032" cy="8.75" r="1.285" />
        <circle cx="7.032" cy="13.156" r="1.285" />
        <circle cx="16.968" cy="8.75" r="1.285" />
        <circle cx="16.968" cy="13.156" r="1.285" />
        <circle cx="12" cy="8.75" r="1.285" />
        <circle cx="12" cy="13.156" r="1.285" />
        <circle cx="7.032" cy="17.486" r="1.285" />
        <circle cx="12" cy="17.486" r="1.285" />
      </g>
    </svg>
  );
};

export const ICON_CLOSE = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path
          fill="black"
          d="M13.414 12l5.793-5.793c.39-.39.39-1.023 0-1.414s-1.023-.39-1.414 0L12 10.586 6.207 4.793c-.39-.39-1.023-.39-1.414 0s-.39 1.023 0 1.414L10.586 12l-5.793 5.793c-.39.39-.39 1.023 0 1.414.195.195.45.293.707.293s.512-.098.707-.293L12 13.414l5.793 5.793c.195.195.45.293.707.293s.512-.098.707-.293c.39-.39.39-1.023 0-1.414L13.414 12z"
        />
      </g>
    </svg>
  );
};

export const ICON_DELETE = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M20.746 5.236h-3.75V4.25c0-1.24-1.01-2.25-2.25-2.25h-5.5c-1.24 0-2.25 1.01-2.25 2.25v.986h-3.75c-.414 0-.75.336-.75.75s.336.75.75.75h.368l1.583 13.262c.216 1.193 1.31 2.027 2.658 2.027h8.282c1.35 0 2.442-.834 2.664-2.072l1.577-13.217h.368c.414 0 .75-.336.75-.75s-.335-.75-.75-.75zM8.496 4.25c0-.413.337-.75.75-.75h5.5c.413 0 .75.337.75.75v.986h-7V4.25zm8.822 15.48c-.1.55-.664.795-1.18.795H7.854c-.517 0-1.083-.246-1.175-.75L5.126 6.735h13.74L17.32 19.732z" />
        <path d="M10 17.75c.414 0 .75-.336.75-.75v-7c0-.414-.336-.75-.75-.75s-.75.336-.75.75v7c0 .414.336.75.75.75zm4 0c.414 0 .75-.336.75-.75v-7c0-.414-.336-.75-.75-.75s-.75.336-.75.75v7c0 .414.336.75.75.75z" />
      </g>
    </svg>
  );
};

export const ICON_UPLOAD = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M19.708 22H4.292C3.028 22 2 20.972 2 19.708V7.375C2 6.11 3.028 5.083 4.292 5.083h2.146C7.633 3.17 9.722 2 12 2c2.277 0 4.367 1.17 5.562 3.083h2.146C20.972 5.083 22 6.11 22 7.375v12.333C22 20.972 20.972 22 19.708 22zM4.292 6.583c-.437 0-.792.355-.792.792v12.333c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V7.375c0-.437-.355-.792-.792-.792h-2.45c-.317.05-.632-.095-.782-.382-.88-1.665-2.594-2.7-4.476-2.7-1.883 0-3.598 1.035-4.476 2.702-.16.302-.502.46-.833.38H4.293z" />
        <path d="M12 8.167c-2.68 0-4.86 2.18-4.86 4.86s2.18 4.86 4.86 4.86 4.86-2.18 4.86-4.86-2.18-4.86-4.86-4.86zm2 5.583h-1.25V15c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.25H10c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25V11c0-.414.336-.75.75-.75s.75.336.75.75v1.25H14c.414 0 .75.336.75.75s-.336.75-.75.75z" />
      </g>
    </svg>
  );
};

export const ICON_NEWLIST = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M23.25 3.25h-2.425V.825c0-.414-.336-.75-.75-.75s-.75.336-.75.75V3.25H16.9c-.414 0-.75.336-.75.75s.336.75.75.75h2.425v2.425c0 .414.336.75.75.75s.75-.336.75-.75V4.75h2.425c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zM18.575 22H4.25C3.01 22 2 20.99 2 19.75V5.5c0-1.24 1.01-2.25 2.25-2.25h8.947c.414 0 .75.336.75.75s-.336.75-.75.75H4.25c-.413 0-.75.336-.75.75v14.25c0 .414.337.75.75.75h14.325c.413 0 .75-.336.75-.75v-8.872c0-.414.336-.75.75-.75s.75.336.75.75v8.872c0 1.24-1.01 2.25-2.25 2.25z" />
        <path d="M16.078 9.583H6.673c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9.405c.414 0 .75.336.75.75s-.336.75-.75.75zm0 3.867H6.673c-.414 0-.75-.337-.75-.75s.336-.75.75-.75h9.405c.414 0 .75.335.75.75s-.336.75-.75.75zm-4.703 3.866H6.673c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.702c.414 0 .75.336.75.75s-.336.75-.75.75z" />
      </g>
    </svg>
  );
};

export const ICON_SEARCH = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z" />
      </g>
    </svg>
  );
};

export const ICON_FEATHER = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        d="M7.35135 10H12.8378M10.1892 7.35135V12.8378"
        stroke="#777D94"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 10C3 15.2496 4.75038 17 10 17C15.2496 17 17 15.2496 17 10C17 4.75038 15.2496 3 10 3C4.75038 3 3 4.75038 3 10Z"
        stroke="#777D94"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_LIGHT = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 512 512">
      <g>
        <path
          fill="currentColor"
          d="M502.42 240.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.41-94.8a17.31 17.31 0 0 0-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4a17.31 17.31 0 0 0 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.41-33.5 47.3 94.7a17.31 17.31 0 0 0 31 0l47.31-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3a17.33 17.33 0 0 0 .2-31.1zm-155.9 106c-49.91 49.9-131.11 49.9-181 0a128.13 128.13 0 0 1 0-181c49.9-49.9 131.1-49.9 181 0a128.13 128.13 0 0 1 0 181z"
        />
        <path
          fill="currentColor"
          d="M352 256a96 96 0 1 1-96-96 96.15 96.15 0 0 1 96 96z"
        />
      </g>
    </svg>
  );
};

export const ICON_DARK = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 512 512">
      <g>
        <path
          fill="currentColor"
          d="M320 32L304 0l-16 32-32 16 32 16 16 32 16-32 32-16zm138.7 149.3L432 128l-26.7 53.3L352 208l53.3 26.7L432 288l26.7-53.3L512 208z"
        />
        <path
          fill="currentColor"
          d="M332.2 426.4c8.1-1.6 13.9 8 8.6 14.5a191.18 191.18 0 0 1-149 71.1C85.8 512 0 426 0 320c0-120 108.7-210.6 227-188.8 8.2 1.6 10.1 12.6 2.8 16.7a150.3 150.3 0 0 0-76.1 130.8c0 94 85.4 165.4 178.5 147.7z"
        />
      </g>
    </svg>
  );
};

export const ICON_NEWMSG = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M23.25 3.25h-2.425V.825c0-.414-.336-.75-.75-.75s-.75.336-.75.75V3.25H16.9c-.414 0-.75.336-.75.75s.336.75.75.75h2.425v2.425c0 .414.336.75.75.75s.75-.336.75-.75V4.75h2.425c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zm-3.175 6.876c-.414 0-.75.336-.75.75v8.078c0 .414-.337.75-.75.75H4.095c-.412 0-.75-.336-.75-.75V8.298l6.778 4.518c.368.246.79.37 1.213.37.422 0 .844-.124 1.212-.37l4.53-3.013c.336-.223.428-.676.204-1.012-.223-.332-.675-.425-1.012-.2l-4.53 3.014c-.246.162-.563.163-.808 0l-7.586-5.06V5.5c0-.414.337-.75.75-.75h9.094c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H4.096c-1.24 0-2.25 1.01-2.25 2.25v13.455c0 1.24 1.01 2.25 2.25 2.25h14.48c1.24 0 2.25-1.01 2.25-2.25v-8.078c0-.415-.337-.75-.75-.75z" />
      </g>
    </svg>
  );
};

export const ICON_SEND = (props) => {
  return (
    <svg style={props.styles} viewBox="0 0 24 24">
      <g>
        <path d="M21.13 11.358L3.614 2.108c-.29-.152-.64-.102-.873.126-.23.226-.293.577-.15.868l4.362 8.92-4.362 8.92c-.143.292-.08.643.15.868.145.14.333.212.523.212.12 0 .24-.028.35-.087l17.517-9.25c.245-.13.4-.386.4-.664s-.155-.532-.4-.662zM4.948 4.51l12.804 6.762H8.255l-3.307-6.76zm3.307 8.26h9.498L4.948 19.535l3.307-6.763z" />
      </g>
    </svg>
  );
};

export const ICON_TAG = (props) => {
  return (
    <svg
      width="31"
      height="38"
      style={props.styles}
      viewBox="0 0 31 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.55495 15.0521C-0.296962 17.042 -0.296962 21.2633 2.55495 23.2531L22.3868 37.0904C25.7013 39.4031 30.2478 37.0316 30.2478 32.9899V5.31532C30.2478 1.27368 25.7013 -1.09788 22.3868 1.2148L2.55495 15.0521ZM10.243 23.152C12.4521 23.152 14.243 21.3611 14.243 19.152C14.243 16.9429 12.4521 15.152 10.243 15.152C8.03382 15.152 6.24296 16.9429 6.24296 19.152C6.24296 21.3611 8.03382 23.152 10.243 23.152Z"
        fill="white"
      />
    </svg>
  );
};

export const ICON_CAR = ({ width = 24, height = 24, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.styles}
    >
      <path
        d="M17.1333 5.875C16.9556 5.35 16.4222 5 15.8889 5H6.11111C5.48889 5 5.04444 5.35 4.86667 5.875L3 11.125V18.125C3 18.5625 3.44444 19 3.88889 19H4.77778C5.31111 19 5.66667 18.5625 5.66667 18.125V17.25H16.3333V18.125C16.3333 18.5625 16.7778 19 17.2222 19H18.1111C18.5556 19 19 18.5625 19 18.125V11.125L17.1333 5.875ZM6 6H16L17.5 10H4.5L6 6ZM18 16H4V11.125H18V16ZM7 12C7.71111 12 8.33333 12.6125 8.33333 13.3125C8.33333 14.0125 7.71111 14.625 7 14.625C6.28889 14.625 5.66667 14.0125 5.66667 13.3125C5.66667 12.6125 6.28889 12 7 12ZM15 12C15.7111 12 16.3333 12.6125 16.3333 13.3125C16.3333 14.0125 15.7111 14.625 15 14.625C14.2889 14.625 13.6667 14.0125 13.6667 13.3125C13.6667 12.6125 14.2889 12 15 12Z"
        fill="#25282C"
        fillOpacity="0.6"
      />
    </svg>
  );
};